import React from 'react';
import moment, { Duration } from 'moment-timezone';
import classNames from 'classnames';
import styles from './ProductType.module.css';

interface Props {
  isAuction: boolean;
  bidsAmount: number;
  timeLeft: Duration | null;
  timeToStart: Duration | null;
}

const getRemainingTimeLabel = (duration: Duration | null) => {
  if (!duration) return null;

  const currentTime = moment();
  const futureTime = currentTime.clone().add(duration);

  if (!futureTime.isAfter(currentTime)) return 'Ended';

  const days = Math.floor(duration.asDays());
  const hours = duration.hours();
  const minutes = duration.minutes();
  const seconds = duration.seconds();

  const result: string[] = [];

  const intervals = {
    d: days,
    h: hours,
    m: minutes,
    s: seconds,
  };

  Array.from(Object.entries(intervals)).map(([label, value]) => {
    if (value) {
      result.push(`${value}${label}`);
    }
  });

  return result.join(' ');
};

const checkIfEnding = (duration: Duration | null) => {
  if (!duration) return false;
  return duration.asMinutes() < 10;
};

const ProductType = ({ isAuction, bidsAmount, timeLeft, timeToStart }: Props) => {
  if (!isAuction) {
    return <span>Buy now</span>;
  }

  const countdown = () => {
    if (timeToStart && timeToStart.asSeconds() > 0) {
      return `Starting in ${getRemainingTimeLabel(timeToStart)}`;
    }

    const timeLeftLabel = getRemainingTimeLabel(timeLeft);
    if (timeLeftLabel === 'Ended') return timeLeftLabel;

    return `Ends in ${getRemainingTimeLabel(timeLeft)}`;
  }

  return (
    <div className={styles.main}>
      <span>{bidsAmount} bids</span>
      <span>&nbsp;-&nbsp;</span>
      <span className={classNames({ [styles.ending]: checkIfEnding(timeLeft) })}>{ countdown() }</span>
    </div>
  );
};

export default ProductType;
